
<micro-select-combo #sel
              placeholder="Servo Model"
              [mode]="mode"
              [(id)]="servoModel"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
